import PropTypes from 'prop-types';
import React from 'react';

class Toggle extends React.Component {
	render() {
		const { id, name, title, checked, handleChange } = this.props;

		return (
			<div className="input">
				<label htmlFor={id}>{title}</label>
				<input type="checkbox" name={name} id={id} onChange={handleChange} checked={checked} />
			</div>
		);
	}
}

export default Toggle;

Toggle.propTypes = {
	checked: PropTypes.bool,
	handleChange: PropTypes.func,
	id: PropTypes.string,
	name: PropTypes.number,
	title: PropTypes.string,
};
